module.exports = __webpack_public_path__ + "static/img/logo.741d1114.png";